export default __webpack_public_path__ + "stroke-width.asset.1a550385aef03a7871cd1c800de95876.svg";